import React from 'react';
import formClasses from '../payment-form-styling/payment-form-styling.scss';
import { StripeCheckoutForm } from '../../stripe-checkout-form';
export class PaymentInformationForm extends React.PureComponent {
  render() {
    const {
      disableWholeForm,
      popupType,
      isFixedStyles
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: formClasses.form,
      "data-block": "PaymentInformationForm"
    }, /*#__PURE__*/React.createElement(StripeCheckoutForm, {
      isFixedStyles: isFixedStyles,
      popupType: popupType,
      disableWholeForm: disableWholeForm
    }));
  }
}